import { useEvents } from '@entities/events/model';
import qs from 'query-string';
import React, { useMemo, useState } from 'react';
import { xhr } from '@shared/config';
import { useAppSelector } from '@shared/hooks';
import type { PaginatedList } from '@shared/types/common';
import { type Event } from '@src/library/models/events';
import { selectTab } from '@src/library/redux/events';

interface Params {
  search?: string;
  tags?: number[];
  module?: number;
  [x: string]: any;
}

export const useEvenList = (api: string, params: Params) => {
  const tab = useAppSelector(selectTab);

  const [status, setStatus] = useState<'idle' | 'loading' | 'fetching'>('idle');
  const [isLoading, setLoading] = useState(false);
  const [hasNext, setHasNext] = useState(true);
  const [page, setPage] = useState(1);
  const [authors, setAuthors] = useState<number[]>([]);
  const [list, setList] = useState<number[]>([]);
  const [events, setEvents] = useState<Event[]>([]);

  const [titles, setTitles] = useState<string[]>([]);

  const controller = useMemo(() => new AbortController(), []);

  const { addEvents } = useEvents();

  const getEvents = React.useCallback(async () => {
    if (status === 'loading' || !hasNext) return;
    setStatus(page === 1 ? 'fetching' : 'loading');
    setLoading(true);

    try {
      // Формируем параметры запроса для выбранной вкладки
      const requestParams: { [key: string]: any } = {
        page: page,
        ...params,
        ...tab.params,
      };

      const response = await xhr.get<PaginatedList<Event>>(api, {
        params: requestParams,
        paramsSerializer: (params) => {
          return qs.stringify(params, { arrayFormat: 'comma' });
        },
        signal: controller.signal,
      });

      if (!response.data) throw response;
      // addEvents(response.data.results);

      const results = response.data.results.map((event) => event.id);

      const title = response.data.results.map((event) => event.title);

      const author = response.data.results.map((event) => event.author.id);

      const authors = response.data.results.map((event) => event.author);
      // doCheckArray(authors) ? authors.forEach((author) => doAddAuthor(author)) : clearAuthorsData();

      const events = response.data.results;

      if (page === 1) {
        setList(results);
        setTitles(title);
        // setAuthors(author);
        setEvents(events);
      } else {
        setList((e) => [...e, ...results]);
        setTitles((e) => [...e, ...title]);
        // setAuthors((e) => [...e, ...authors]);
        setEvents((e) => [...e, ...events]);
      }

      if (response.data.next) {
        setHasNext(true);
        setPage((p) => p + 1);
      } else {
        setHasNext(false);
      }
    } catch (error) {
      console.error(error);
      setHasNext(false);
    } finally {
      setStatus('idle');
      setLoading(false);
    }
  }, [status, hasNext, page, params, api, controller.signal, addEvents]);

  return {
    titles,
    authors,
    ids: list,
    events,
    setEvents,
    hasMore: hasNext,
    getEvents,
    status,
    isLoading,
  };
};
